module.exports = __webpack_public_path__ + "img/cg6.34f1383e.jpg";